import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const MyTeamTask = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("My Team Task"));
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [myTeamTaskdata, setMyTeamTaskData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = {
    ProjectName: { text: "Project", align: "start", visible: true },
    TaskName: { text: "Task", align: "left", visible: true },
    StartDate: { text: "Start Date", align: "center", visible: true },
    EndDate: { text: "End Date", align: "center", visible: true },
    AssignedTo: {
      text: "Assigned To",
      align: "left",
      type: "HTML",
      visible: true,
    },
    AssignedBy: { text: "Assigned By", align: "start", visible: true },
    AssignedDate: { text: "Assigned Date", align: "center", visible: true },
    Status: { text: "Status", align: "center", visible: true },
  };

  useEffect(() => {
    fetchMyTeamTaskApi();
  }, []);

  const [apiStatus, SetApiStatus] = useState(undefined);
  const [projectOptions, setProjectOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const fetchMyTeamTaskApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/5?P_ProjectID=&P_EmployeeID=&P_Status`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const fetchData = response?.data?.data?.data;

        const projectOpt = response?.data?.data?.project?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setProjectOptions(projectOpt);
        const employeeListOpt = response?.data?.data?.employeeList?.map(
          (o) => ({
            value: o.value,
            label: o.text,
          })
        );
        setEmployeeOptions(employeeListOpt);
        const statusOpt = response?.data?.data?.status?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setStatusOptions(statusOpt);
        setMyTeamTaskData(fetchData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    } catch (error) {
      console.log("response-->", error);
    }
  };

  const formDatas = [
    {
      name: "Employee",
      type: "Select",
      options: [...employeeOptions],
    },
    {
      name: "Project",
      type: "Select",
      options: [...projectOptions],
    },
    {
      name: "Status",
      type: "Select",
      options: [...statusOptions],
    },
  ];

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/5?P_ProjectID=${
          filterFormData.find((o) => o.label === "Project")
            ? filterFormData.find((o) => o.label === "Project").value
            : 0
        }&P_EmployeeID=${
          filterFormData.find((o) => o.label === "Employee")
            ? filterFormData.find((o) => o.label === "Employee").value
            : 0
        }&P_Status=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : 0
        }`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.data;
        setMyTeamTaskData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleFilterReset = () => {
    setFilterData([]);
    fetchMyTeamTaskApi();
  };
  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
        <Dynamic_PR_table
          data={myTeamTaskdata}
          columns={columns}
          itemsPerPage={8}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          showIcon1={true}
          showIcon2={false}
          isSorting={true}
          isApiStatus={apiStatus}
          isRequiredStatus={true}
          formDatas={formDatas}
          handleReset={handleFilterReset}
          filterFormData={filterFormData}
          handleGetData={handleGetData}
          isFilterRequired={true}
          handleChange={handleChange}
          showIcon3={false}
          showIcon4={false}
          showIcon5={false}
          isSrNoRequired={false}
          isActionRequired={false}
          isAddNewBtnRequired={false}
          // handleIcon1={handleEdit}
          // handleAddNew={handleAddNewAssetCategory}
          add
          more
          function
          icons={{
            Icon1: <i class="bi bi-pencil-square icons"></i>,
            Icon1Text: " Edit",
          }}
        />
        </div>
      </div>
    </div>
  );
};

export default MyTeamTask;
